/**
 * List collections — fade tiles into view on scroll (Chanel-style editorial).
 */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.getAttribute('data-tcn-list-fade-ready') === '1') return;
    root.setAttribute('data-tcn-list-fade-ready', '1');

    var items = root.querySelectorAll('[data-tcn-list-fade]');
    if (!items.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { root: null, rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    items.forEach(function (el) {
      observer.observe(el);
    });
  }

  function boot() {
    document.querySelectorAll('.tcn-list-collections').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    var root = event.target.querySelector
      ? event.target.querySelector('.tcn-list-collections')
      : null;
    if (root) init(root);
  });
})();
